var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-card',{staticClass:"bg-default-card",attrs:{"header":_vm.currentView == ''
        ? _vm.uLang('app.loading') + '...'
        : _vm.uLang('app.' + _vm.currentView),"header-tag":"h4"}},[(_vm.currentView != '')?_c(_vm.loadComponent,{tag:"component",attrs:{"settingId":_vm.id}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }